'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoFork = function IoFork(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.1 11.6z m3.9 1.4c0 2-1.2 3.7-2.9 4.5-0.9 0.5-0.8 0.9-0.8 0.9s1.2 15.6 1.2 16.6-0.2 1.4-0.7 1.9-1.2 0.6-1.8 0.6-1.2-0.2-1.7-0.6-0.8-1-0.8-1.9 1.3-16.6 1.3-16.6 0-0.5-0.9-0.9c-1.7-0.8-2.9-2.5-2.9-4.5 0-3.4 1.2-7.3 1.9-10.5h0.6v9.1c0 0.5 0.2 0.9 0.7 0.9s0.7-0.3 0.8-0.8v-0.1l0.7-9.1h0.6l0.8 9.1v0.1c0.1 0.5 0.2 0.8 0.7 0.8s0.7-0.4 0.7-0.9v-9.1h0.6c0.7 3.1 1.9 7.1 1.9 10.5z' })
        )
    );
};

exports.default = IoFork;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/fork.js
// module id = 2032
// module chunks = 0